/* Slider motion for Dawn slider components (owner, 2026-08-02).
   Two ways to move a carousel with a mouse, no clicking required:

   1. HOVER ARROWS — zones at the left/right edges of every slider;
      resting the mouse on one scrolls continuously (ramping up gently),
      leaving it eases the slider onto the nearest card. Arrows appear
      when the slider is hovered and hide at the ends of the strip.
   2. DRAG — grab anywhere and pull, with touch-like physics: velocity
      is kept on release, glides out with friction, then eases onto the
      nearest card. A real drag swallows the click that follows it, so
      cards open on a plain click but never on a drag release.

   Scroll-snap is suspended while either is moving the slider (it fights
   live scrollLeft updates — restoring it early teleports, which was the
   v1 jank) and restored only after the ease-to-card finishes. */
(function () {
  var FRICTION = 0.94;
  var MIN_V = 0.4;

  function stopAnim(slider) {
    if (slider._mgRaf) { cancelAnimationFrame(slider._mgRaf); slider._mgRaf = null; }
  }

  function snapOff(slider) {
    if (slider._mgSnapOff) return;
    slider._mgSavedSnap = slider.style.scrollSnapType;
    slider.style.scrollSnapType = "none";
    slider._mgSnapOff = true;
  }

  function snapRestore(slider) {
    if (!slider._mgSnapOff) return;
    slider.style.scrollSnapType = slider._mgSavedSnap || "";
    slider._mgSnapOff = false;
  }

  /* Ease onto the nearest card edge, then restore snap. */
  function settle(slider, forced) {
    var slides = slider.querySelectorAll(".slider__slide");
    var target = null;
    var best = Infinity;
    slides.forEach(function (s) {
      var d = Math.abs(s.offsetLeft - slider.scrollLeft);
      if (d < best) { best = d; target = s.offsetLeft; }
    });
    var max = slider.scrollWidth - slider.clientWidth;
    if (typeof forced === "number") target = forced;
    if (target === null) { snapRestore(slider); return; }
    if (target > max) target = max;
    var from = slider.scrollLeft;
    var delta = target - from;
    var t0 = performance.now();
    function step(now) {
      var t = Math.min(1, (now - t0) / 260);
      slider.scrollLeft = from + delta * (1 - Math.pow(1 - t, 3));
      if (t < 1) {
        slider._mgRaf = requestAnimationFrame(step);
      } else {
        slider._mgRaf = null;
        snapRestore(slider);
      }
    }
    stopAnim(slider);
    slider._mgRaf = requestAnimationFrame(step);
  }

  /* ---------------------------------------------------- hover arrows -- */
  function addHoverZones(comp) {
    var slider = comp.querySelector("ul.slider");
    if (!slider || comp.querySelector(".mg-hoverscroll")) return;

    [-1, 1].forEach(function (dir) {
      var zone = document.createElement("div");
      zone.className = "mg-hoverscroll mg-hoverscroll--" +
        (dir < 0 ? "left" : "right");
      zone.setAttribute("aria-hidden", "true");
      zone.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" width="26" height="26"><path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 24 24" width="26" height="26"><path d="m9 4 8 8-8 8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      comp.appendChild(zone);

      zone.addEventListener("pointerenter", function (e) {
        if (e.pointerType !== "mouse") return;
        if (slider.scrollWidth <= slider.clientWidth + 8) return;
        stopAnim(slider);
        snapOff(slider);
        var t0 = performance.now();
        function scrollStep(now) {
          // ramp: 4.5 px/frame up to ~18 over the first 500ms
          var ramp = Math.min(1, (now - t0) / 500);
          slider.scrollLeft += dir * (4.5 + 13 * ramp);
          var atStart = slider.scrollLeft <= 0;
          var atEnd = slider.scrollLeft >=
            slider.scrollWidth - slider.clientWidth - 1;
          if ((dir < 0 && atStart) || (dir > 0 && atEnd)) {
            settle(slider, dir > 0
              ? slider.scrollWidth - slider.clientWidth
              : 0);
          } else {
            slider._mgRaf = requestAnimationFrame(scrollStep);
          }
        }
        slider._mgRaf = requestAnimationFrame(scrollStep);
      });

      zone.addEventListener("pointerleave", function () {
        if (slider._mgSnapOff) settle(slider);
      });
    });

    /* hide each arrow at its end of the strip */
    function updateZones() {
      var atStart = slider.scrollLeft <= 2;
      var atEnd = slider.scrollLeft >=
        slider.scrollWidth - slider.clientWidth - 2;
      comp.querySelector(".mg-hoverscroll--left")
        .classList.toggle("mg-hoverscroll--off", atStart);
      comp.querySelector(".mg-hoverscroll--right")
        .classList.toggle("mg-hoverscroll--off", atEnd);
    }
    slider.addEventListener("scroll", updateZones, { passive: true });
    updateZones();
  }

  /* ------------------------------------------------------ auto-drift -- */
  /* Homepage Design Center carousel only (owner, 2026-08-02): drifts
     across on its own once it scrolls into view, freezes while the
     mouse is anywhere over it (so cards are readable), resumes on
     leave. Edge arrows and drag take priority whenever they're active.
     Ping-pongs at the ends. Desktop mice only; skipped entirely for
     touch devices and prefers-reduced-motion. */
  function addAutoDrift(comp) {
    // Homepage Design Center carousel, plus any section that opts in with
    // data-mg-autodrift="1" (the DTF customer-photo carousel, 2026-08-03).
    if (!comp.closest('[id*="design_center_carousel"]') &&
        comp.dataset.mgAutodrift !== "1") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;
    var slider = comp.querySelector("ul.slider");
    if (!slider) return;

    var SPEED = 0.7;                // px per frame — a browse, not a chase
    var inView = false;
    var hovered = false;
    // data-mg-drift-dir="-1" starts a row travelling the other way (owner
    // 2026-09-12, on the two-row Design Center strip: "another row going the
    // same speed but the oppisote direction"). SPEED is deliberately NOT
    // per-row — same constant, opposite sign, which is what "same speed"
    // means and what keeps the two rows from slowly falling out of step.
    var dir = comp.dataset.mgDriftDir === "-1" ? -1 : 1;
    // A row that drifts LEFT has to start at the right-hand end or it is
    // already against its wall and ping-pongs immediately.
    var startedAtEnd = dir !== -1;

    function tick() {
      slider._mgAutoRaf = null;
      // a gallery lightbox being open pauses the drift outright (owner)
      if (document.querySelector(".mg-gallery__dialog[open]")) { schedule(); return; }
      if (!inView) return;
      if (slider._mgRaf) { schedule(); return; }   // manual motion owns it
      if (slider.scrollWidth <= slider.clientWidth + 8) { schedule(); return; }
      snapOff(slider);
      // ⚖️ HOVER SLOWS IT, IT NEVER STOPS IT (owner 2026-09-12: "takes the
      // whole screen and have nowhere to rest mouse"). Freezing was fine when
      // the strip was one row you could move away from; with two rows filling
      // the fold the pointer is almost always over one, so the motion was
      // almost always dead — and every exit made both rows lurch back into
      // life. A crawl keeps the card readable, keeps the page alive, and
      // leaves nothing to "rest" away from. Per row, so the other one is
      // untouched.
      var step = hovered ? SPEED * 0.15 : SPEED;
      if (!startedAtEnd) {
        slider.scrollLeft = slider.scrollWidth - slider.clientWidth;
        startedAtEnd = true;
      }
      slider.scrollLeft += dir * step;
      var max = slider.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft >= max - 1) dir = -1;
      else if (slider.scrollLeft <= 1) dir = 1;
      schedule();
    }
    function schedule() {
      if (!slider._mgAutoRaf) slider._mgAutoRaf = requestAnimationFrame(tick);
    }

    comp.addEventListener("pointerenter", function (e) {
      if (e.pointerType === "mouse") hovered = true;
    });
    comp.addEventListener("pointerleave", function (e) {
      if (e.pointerType === "mouse") { hovered = false; schedule(); }
    });

    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView) schedule();
    }, { threshold: 0.35 }).observe(comp);
  }

  /* The DOT/boat lettering DESIGNER lives on its own page — their product
     pages are bare variant listings where a customer could order without
     entering their numbers (unproducible). Carousel cards for those
     products route to the designer instead (owner, 2026-08-02). */
  function retargetLetteringCards(comp) {
    if (!comp.closest('[id*="design_center_carousel"]')) return;
    comp.querySelectorAll('a[href*="/products/usdot-number-decal"]')
      .forEach(function (a) { a.href = "/pages/dot-boat-lettering"; });
    comp.querySelectorAll('a[href*="/products/boat-lettering"]')
      .forEach(function (a) { a.href = "/pages/boat-lettering"; });
  }

  function initAll() {
    document.querySelectorAll("slider-component").forEach(function (comp) {
      addHoverZones(comp);
      addAutoDrift(comp);
      retargetLetteringCards(comp);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* ------------------------------------------------------------ drag -- */
  document.addEventListener("pointerdown", function (e) {
    if (e.pointerType !== "mouse" || e.button !== 0) return;
    if (e.target.closest(".mg-hoverscroll")) return;
    var slider = e.target.closest("ul.slider");
    if (!slider || slider.scrollWidth <= slider.clientWidth + 8) return;
    stopAnim(slider);

    var startX = e.clientX;
    var startLeft = slider.scrollLeft;
    var lastX = e.clientX;
    var lastT = performance.now();
    var v = 0;
    var dragged = false;

    function move(ev) {
      var now = performance.now();
      var dx = ev.clientX - startX;
      if (!dragged && Math.abs(dx) > 5) {
        dragged = true;
        snapOff(slider);
        slider.classList.add("mg-dragging");
      }
      if (!dragged) return;
      slider.scrollLeft = startLeft - dx;
      var dt = now - lastT;
      if (dt > 0) v = ((ev.clientX - lastX) / dt) * 16;
      lastX = ev.clientX;
      lastT = now;
      ev.preventDefault();
    }

    function glide() {
      v *= FRICTION;
      slider.scrollLeft -= v;
      var atStart = slider.scrollLeft <= 0;
      var atEnd = slider.scrollLeft >=
        slider.scrollWidth - slider.clientWidth - 1;
      if (Math.abs(v) > MIN_V && !atStart && !atEnd) {
        slider._mgRaf = requestAnimationFrame(glide);
      } else if (atEnd) {
        settle(slider, slider.scrollWidth - slider.clientWidth);
      } else if (atStart) {
        settle(slider, 0);
      } else {
        settle(slider);
      }
    }

    function up() {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      if (!dragged) return;
      slider.classList.remove("mg-dragging");
      slider.addEventListener("click", function squash(ce) {
        ce.preventDefault();
        ce.stopPropagation();
      }, { capture: true, once: true });
      slider._mgRaf = requestAnimationFrame(glide);
    }

    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  });
})();
